import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DownloadFileService } from 'gung-standard';
import { format, subDays } from 'date-fns';
import { first } from 'rxjs';
import { OttoFilterSearchLogEntry, SpringPage } from '../../models/otto-olsen-cross-reference';
import { OttoOlsenCrossReferenceAdminService } from '../../services/otto-olsen-cross-reference-admin.service';

@Component({
  selector: 'otto-olsen-cross-reference-stats',
  templateUrl: './otto-olsen-cross-reference-stats.component.html',
  styleUrls: ['./otto-olsen-cross-reference-stats.component.scss'],
  standalone: false
})
export class OttoOlsenCrossReferenceStatsComponent implements OnInit {
  fromDate: string = format(subDays(new Date(), 30), 'yyyy-MM-dd');
  toDate: string = format(new Date(), 'yyyy-MM-dd');
  page?: SpringPage<OttoFilterSearchLogEntry>;
  loading = false;
  exporting = false;

  constructor(
    protected adminService: OttoOlsenCrossReferenceAdminService,
    protected downloadFileService: DownloadFileService
  ) {}

  ngOnInit(): void {
    this.load(0);
  }

  setPreset(days: number): void {
    this.fromDate = format(subDays(new Date(), days), 'yyyy-MM-dd');
    this.toDate = format(new Date(), 'yyyy-MM-dd');
    this.load(0);
  }

  onFromDateChange(value: string): void {
    if (!value) {
      return;
    }
    this.load(0);
  }

  onToDateChange(value: string): void {
    if (!value) {
      return;
    }
    this.load(0);
  }

  load(pageNumber: number): void {
    if (!this.fromDate || !this.toDate) {
      return;
    }
    this.loading = true;
    this.adminService
      .stats(this.fromDate, this.toDate, pageNumber)
      .pipe(first())
      .subscribe({
        next: page => {
          this.page = page;
          this.loading = false;
        },
        error: () => (this.loading = false)
      });
  }

  renderHitsPerSource(entry: OttoFilterSearchLogEntry): string {
    if (!entry.hitsPerSource) {
      return '';
    }
    return Object.entries(entry.hitsPerSource)
      .map(([source, count]) => `${source}=${count}`)
      .join(', ');
  }

  export(): void {
    if (!this.fromDate || !this.toDate || this.exporting) {
      return;
    }
    this.exporting = true;
    this.adminService
      .statsExportExcel(this.fromDate, this.toDate)
      .pipe(first())
      .subscribe({
        next: response => {
          this.exporting = false;
          if (!response.body) {
            return;
          }
          // The DownloadFileService extracts the filename from Content-Disposition
          // and triggers a normal browser download — no popup-blocker concerns.
          const file = this.downloadFileService.create(response as unknown as HttpResponse<ArrayBuffer>);
          this.downloadFileService.download(file);
        },
        error: () => (this.exporting = false)
      });
  }
}
